import { render } from "./vertical-splitter.vue?vue&type=template&id=ebd84c22&ts=true"
import script from "./vertical-splitter.vue?vue&type=script&lang=ts"
export * from "./vertical-splitter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__